import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  DataCollectionApi,
  IncomeOtherRequest,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const submitOtherIncome = createAsyncThunk<
  IncomeOtherRequest,
  IncomeOtherRequest,
  ThunkApi
>("submitOtherIncome", async (otherIncomeData, { rejectWithValue }) => {
  try {
    await new DataCollectionApi().addIncomeOther(otherIncomeData);

    return otherIncomeData;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Salvataggio altre entrate",
      description:
        "Non siamo riusciti a salvare le tue altre entrate.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
